// src/components/Layout/SuperadminLayout.tsx
import React from 'react';
import Sidebar from './Sidebar';

import { useTheme } from '../../contexts/ThemeContext';

interface SuperadminLayoutProps {
  children: React.ReactNode;
}

const SuperadminLayout: React.FC<SuperadminLayoutProps> = ({ children }) => {
  const { isCollapsed } = useTheme();

  return (
    <div className="flex h-screen bg-gray-100 dark:bg-slate-900 transition-colors">
      <Sidebar />
      
      <div className={`flex-1 ${isCollapsed ? 'md:ml-20' : 'md:ml-64'} transition-all duration-300 overflow-y-auto`}>
        <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-slate-900 dark:to-slate-800 min-h-full transition-colors">
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperadminLayout;